import { createAction, props } from '@ngrx/store';
import { User } from './auth.models';
import { Registration } from 'src/app/core/models/registration';

// Register action
export const Register = createAction('[Authentication] Register', props<{ registration: Registration }>());
export const RegisterSuccess = createAction('[Authentication] Register Success', props<{ user: User }>());
export const RegisterFailure = createAction('[Authentication] Register Failure', props<{ error: string }>());

// login action
export const login = createAction('[Authentication] Login', props<{ loginForm:any }>());
export const loginSuccess = createAction('[Authentication] Login Success', props<{ user: any }>());
export const loginFailure = createAction('[Authentication] Login Failure', props<{ error: string }>());


// logout action
export const logout = createAction('[Authentication] Logout');

export const logoutSuccess = createAction('[Auth] Logout Success');


